import React from 'react';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { Expandable } from '@AMIEWEB/Common';
import { Title } from '../customComponents/OrderPreferencesDesign';
import { useTranslation } from 'react-i18next';
import { OrderTargetMarginsGrid } from './OrderTargetMarginsGrid';

export const TargetMargins = ({apiRef}) => {
  const { t } = useTranslation();
  
  return (
    <React.Fragment>
      <Expandable
        expanded
        titleComponent={<Title>{t('order.orderDetails.preferences.targetMargins.title')}</Title>}
        unmountOnExit={false}
      >
        <LayoutGrid xs={13} direction="column" spacing={2}>
          <LayoutGridItem>
            <OrderTargetMarginsGrid apiRef={apiRef} />
          </LayoutGridItem>
        </LayoutGrid>
      </Expandable>
    </React.Fragment>
  );
};
